package com.kinoshazam.uiKit.components.menuItem

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier

@Composable
fun UiKitHorizontalSlotsItem(
    modifier: Modifier = Modifier,
    leadContent: @Composable () -> Unit = {},
    middleContent: @Composable () -> Unit = {},
    trailingContent: @Composable () -> Unit = {},
) {

    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.Start,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        leadContent()
        middleContent()
        trailingContent()
    }
}